import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react"; // You can use any icon library you prefer
import backArrow from "../../assets/images/white_back.png"; // Keep for reuse

const HamburgerMenuHeader = ({ title }) => {
  const navigate = useNavigate();

  return (
    // <header className="flex items-center justify-between px-4 py-3 bg-blue-[#004990] text-white shadow-md">
    //   {/* Back Button */}
    //   <button
    //     onClick={() => navigate(-1)} // Go back to previous page
    //     className="flex items-center gap-2 text-white hover:text-gray-200 transition"
    //   >
    //     <ArrowLeft size={20} />
    //     {/* <span className="text-sm">Back</span> */}
    //   </button>

    //   {/* Centered Title */}

    //   <div className="flex items-center gap-3 ml-4">
    //     {/* <img src={userAvatar} alt="avatar" className="w-8 h-8 rounded-full border-2 border-white" /> */}
    //     <h1 className="text-white font-semibold text-lg">{title}</h1>
    //     {/* <h1 className="text-lg font-semibold text-center flex-1 mr-6">
    //       {title}
    //     </h1> */}
    //   </div>
    // </header>
    <header className="w-full bg-[#004990] sticky top-0 px-4 py-4 relative z-50">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <button
          onClick={() => navigate(-1)}
          className="text-white  p-1 rounded-full"
        >
          <img src={backArrow} alt="←" className="w-6 h-6 object-contain" />
        </button>
        <div className="flex items-center gap-3 ml-4">
          {/* <img src={userAvatar} alt="avatar" className="w-8 h-8 rounded-full border-2 border-white" /> */}
          <h1 className="text-white font-semibold text-lg">{title}</h1>
        </div>
      </div>
    </header>
  );
};

export default HamburgerMenuHeader;
